module.exports = __webpack_public_path__ + "static/5.554a50fb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/assessment/5.png
// module id = 872
// module chunks = 69039249851653 261756379115546